/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionnofavorites2Inputs */

const en_actionnofavorites2 = /** @type {(inputs: Actionnofavorites2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No favourites yet. The action still shows on your place page and in the feed.`)
};

const de_actionnofavorites2 = /** @type {(inputs: Actionnofavorites2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Favoriten. Die Aktion steht trotzdem auf deiner Ortsseite und im Feed.`)
};

/**
* | output |
* | --- |
* | "No favourites yet. The action still shows on your place page and in the feed." |
*
* @param {Actionnofavorites2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionnofavorites2 = /** @type {((inputs?: Actionnofavorites2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionnofavorites2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionnofavorites2(inputs)
	return de_actionnofavorites2(inputs)
});
export { actionnofavorites2 as "actionNoFavorites" }